import { render, staticRenderFns } from "./edit_profile.vue?vue&type=template&id=56571614"
import script from "./edit_profile.vue?vue&type=script&lang=js"
export * from "./edit_profile.vue?vue&type=script&lang=js"
import style0 from "./edit_profile.vue?vue&type=style&index=0&id=56571614&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports